import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import SwiperCore, { Navigation, Pagination, A11y } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper-bundle.min.css"
import "./style.scss"

SwiperCore.use([Navigation, Pagination, A11y])

const Banner = ({}) => {
  return (
    <div className="banner">
      <Swiper
        loop
        pagination={{
          el: ".swiper-pagination",
          bulletClass: "my-bullet", //需设置.my-bullet样式
          bulletActiveClass: "my-bullet-active",
          clickable: true,
        }}
        navigation={{
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
          clickable: true,
        }}
        slidesPerView={1}
      >
        <SwiperSlide>
          <StaticImage
            className="d-none d-md-block"
            loading="lazy"
            layout="fullWidth"
            placeholder="blurred"
            src="../../assets/images/banner1.png"
            quality={95}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="微信/小程序开发"
            title="微信/小程序开发"
          />
          <StaticImage
            className="d-block d-md-none"
            loading="lazy"
            layout="fullWidth"
            placeholder="blurred"
            src="../../assets/images/ydd-banner1.png"
            quality={95}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="微信/小程序开发"
            title="微信/小程序开发"
          />
        </SwiperSlide>
        <SwiperSlide>
          <StaticImage
            className="d-none d-md-block"
            loading="lazy"
            layout="fullWidth"
            placeholder="blurred"
            src="../../assets/images/banner2.png"
            quality={95}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="精品APP定制应用定制开发"
            title="精品APP定制应用定制开发"
          />
          <StaticImage
            className="d-block d-md-none"
            loading="lazy"
            layout="fullWidth"
            placeholder="blurred"
            src="../../assets/images/ydd-banner2.png"
            quality={95}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="精品APP定制应用定制开发"
            title="精品APP定制应用定制开发"
          />
        </SwiperSlide>
        <SwiperSlide>
          <StaticImage
            className="d-none d-md-block"
            loading="lazy"
            layout="fullWidth"
            placeholder="blurred"
            src="../../assets/images/banner3.png"
            quality={95}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="网站建设"
            title="网站建设"
          />
          <StaticImage
            className="d-block d-md-none"
            loading="lazy"
            layout="fullWidth"
            placeholder="blurred"
            src="../../assets/images/ydd-banner3.png"
            quality={95}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="网站建设"
            title="网站建设"
          />
        </SwiperSlide>
        <div className="swiper-pagination"></div>
        <div className="swiper-button-prev"></div>
        <div className="swiper-button-next"></div>
      </Swiper>
    </div>
  )
}

export default Banner
